const topics = [
  { name: '娱乐圈八卦', count: '12.8万', hot: true },
  { name: '网红爆料', count: '9.6万', hot: true },
  { name: '综艺名场面', count: '8.3万', hot: false },
  { name: '明星恋情', count: '15.2万', hot: true },
  { name: '影视剧透', count: '7.1万', hot: false },
  { name: '品牌代言', count: '6.5万', hot: false },
  { name: '时尚穿搭', count: '5.9万', hot: false },
  { name: '社会热点', count: '11.4万', hot: true },
  { name: '国际娱乐', count: '4.7万', hot: false },
  { name: '每日吃瓜', count: '18.6万', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">话题标签</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            按话题标签浏览，快速找到感兴趣的内容方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#index"
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer ${
                topic.hot
                  ? 'border-primary-200 bg-primary-50/70 hover:bg-primary-100 hover:border-primary-300'
                  : 'border-background-200 bg-background-50 hover:bg-secondary-50 hover:border-secondary-200'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
              )}
              <span className={`text-sm font-label whitespace-nowrap ${
                topic.hot ? 'text-primary-700 font-medium' : 'text-foreground-600'
              }`}>
                {topic.name}
              </span>
              <span className={`text-xs font-label whitespace-nowrap ${
                topic.hot ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}